import Guid from "common/values/guid/guid";
import Subscriber from "messaging/values/subcriber/subscriber";

export default class SubscriberAPIResponse {
    userId?: string;
    legalEntityId?: string;

    constructor(partial?: Partial<SubscriberAPIResponse>) {
        if (partial) {
            Object.assign(this, partial);
        }
    }

    deserialize(): Subscriber {
        if (!this.userId) {
            throw new Error("Subscriber userId not returned.");
        }
        if (!this.legalEntityId) {
            throw new Error("Subscriber entityId not returned.");
        }
        return new Subscriber(new Guid(this.userId), new Guid(this.legalEntityId));
    }
}